//itbdw
// export const BASE_HOST = 'http://192.168.2.214:8000'

//beta
// export const BASE_HOST = "http://39.106.139.35";
// export const BASE_HOST = 'http://74db138637d611e887f852540025c377.afdian.net';

//pro
export const BASE_HOST = "https://afdian.net";

// 初始化配置
export const GET_INIT_CONFIG = {
    name: "GET_INIT_CONFIG",
    url: "/api/init/config",
    method: "get",
    data: {},
};

// 日志打点
export const POST_LOG_COLLECT = {
    name: "POST_LOG_COLLECT",
    url: "/api/log/collect",
    method: "post",
    data: { stat_id: "", uri: "", refer: "" },
};

//获取验证码
export const POST_VERIFY_CODE = {
    name: "POST_VERIFY_CODE",
    url: "/api/passport/send-verify-code",
    method: "post",
    data: { account: "", password: "", name: "" },
};

//注册
export const POST_REG = {
    name: "POST_REG",
    url: "/api/passport/register",
    method: "post",
    data: { account: "", password: "", name: "", code: "", mp_token: "" },
};

//登录
export const POST_LOGIN = {
    name: "POST_LOGIN",
    url: "/api/passport/login",
    method: "post",
    data: { account: "", password: "", mp_token: "" },
};

//快速登录
export const POST_QUICK_LOGIN = {
    name: "POST_QUICK_LOGIN",
    url: "/api/passport/quick-login",
    method: "post",
    data: { account: "", code: "", mp_token: "" },
};

//快速登录 发验证码
export const POST_QUICK_LOGIN_CODE = {
    name: "POST_QUICK_LOGIN_CODE",
    url: "/api/passport/send-quick-login-code",
    method: "post",
    data: { account: "" },
};

//忘记密码 发验证码
export const POST_SEND_FORGET_CODE = {
    name: "POST_SEND_FORGET_CODE",
    url: "/api/passport/send-forget-code",
    method: "post",
    data: { account: "" },
};

//忘记密码 检查验证码
export const POST_CHECK_FORGET_CODE = {
    name: "POST_CHECK_FORGET_CODE",
    url: "/api/passport/check-forget-code",
    method: "post",
    data: { account: "", code: "" },
};

//忘记密码 重置密码
export const POST_RESET_PASSWORD = {
    name: "POST_RESET_PASSWORD",
    url: "/api/passport/reset-password",
    method: "post",
    data: { token: "", password: "" },
};

//注销
export const GET_LOGOUT = {
    name: "GET_LOGOUT",
    url: "/api/passport/logout",
    method: "get",
    data: {},
};

//获取登录用户
export const GET_SESSION_USER = {
    name: "GET_SESSION_USER",
    url: "/api/my/profile",
    method: "get",
    data: {},
};

//获取创作者分类
export const GET_CATEGORY_LIST = {
    name: "GET_CATEGORY_LIST",
    url: "/api/category/list",
    method: "get",
    data: {},
};

//获取创作者分类 V2
export const GET_CATEGORY_EDIT_LIST = {
    name: "GET_CATEGORY_EDIT_LIST",
    url: "/api/category/edit-list",
    method: "get",
    data: {},
};

//编辑创作者资料
export const POST_EDIT_BASIC = {
    name: "POST_EDIT_BASIC",
    url: "/api/creator/edit-basic",
    method: "post",
    data: {
        name: "",
        avatar: "",
        url_slug: "",
        category_id: "",
        type: "",
        doing: "",
        detail: "",
        pic: "",
        cover: "",
        watermark:''
    },
};

//新增或编辑单个赞助方案
export const POST_EDIT_PLAN = {
    name: "POST_EDIT_PLAN",
    url: "/api/creator/edit-plan",
    method: "post",
    data: {
        plan_id: "",
        name: "",
        price: "",
        desc: "",
        pic: "",
        status: "",
        reply_switch: "", // 0,1 是否启用
        reply_content: "", //通用回复内容
        reply_random_switch: "", // 0,1 是否启用
        reply_random_content: "", //随机回复内容 }
        independent: "", // 0,1 是否启用
        permanent: "", // 0,1 是否永久
        product_type: "", // 0,1 是否售卖
        sku: [], // [{id,name,stock,reply_content,reply_random_content}]
        need_address: "", // 0,1 是否需要地址
        pay_month:"", //1、3、12
        favorable_price:'', //自定义折扣
        product_discount_price:"", //售卖商品折扣价
        product_vip_price:'',
        vip_price_related_plan_ids:'',

        has_time_limit_price: 0, // 是否有显示折扣
        time_limit_begin: '', // 限时折扣开启时间
        time_limit_end:'', // 限时折扣结束时间
        time_limit_price: '', // 显示折扣价格
        time_limit_discount:'', // 限时折扣的折扣

        product_type:'', //捆绑包类型 2 || 3
        bundle_stock:'', //捆绑包库存
        bundle_sku_select_count:'', //自选数量

        product_vip_price_include_history: 0,

        has_plan_config:0,
        remark_name:'',
        remark_placeholder:'',
        remark_required:'',
    },
};

//删除赞助方案
export const POST_DEL_PLAN = {
    name: "POST_DEL_PLAN",
    url: "/api/creator/delete-plan",
    method: "post",
    data: { plan_id: "" },
};

//编辑收款方式
export const POST_EDIT_WITHDRAW = {
    name: "POST_EDIT_WITHDRAW",
    url: "/api/creator/edit-withdraw",
    method: "post",
    data: { realname: "", account: "",type: '' }, //type 1 支付宝 2 PayPal
};

//获取所有赞助方案
export const GET_ALL_PLANS = {
    name: "GET_ALL_PLANS",
    url: "/api/creator/all-plans",
    method: "get",
    data: {post_only: '',sale_only: '',status: ''},
};

//获取收款方式
export const GET_WITHDRAW_METHOD = {
    name: "GET_WITHDRAW_METHOD",
    url: "/api/creator/withdraw-method",
    method: "get",
    data: {},
};

//获取他人资料
export const GET_USER_PROFILE = {
    name: "GET_USER_PROFILE",
    url: "/api/user/get-profile",
    method: "get",
    data: { user_id: "" },
};

//获取他人资料 by slug
export const GET_USER_PROFILE_BY_SLUG = {
    name: "GET_USER_PROFILE_BY_SLUG",
    url: "/api/user/get-profile-by-slug",
    method: "get",
    data: { url_slug: "" },
};

//获取他人支持计划
export const GET_CREATOR_PLANS = {
    name: "GET_CREATOR_PLANS",
    url: "/api/creator/get-plans",
    method: "get",
    data: { user_id: "", album_id: "" , unlock_plan_ids: "" },
};

//准备订单
export const GET_ORDER_PREPARE = {
    name: "GET_ORDER_PREPARE",
    url: "/api/order/prepare",
    method: "post",
    data: { plan_id: "", user_id: "", sku_detail: "", product_type:'' },
};

//准备售卖订单
export const GET_ORDER_PREPARE_PRODUCT = {
    name: "GET_ORDER_PREPARE_PRODUCT",
    url: "/api/order/prepare-product ",
    method: "get",
    data: { plan_id: "", sku_detail: "" },
};

//下订单
export const POST_CREATE_ORDER = {
    name: "POST_CREATE_ORDER",
    url: "/api/order/create-order",
    method: "post",
    data: {
        plan_id: "",
        month: "",
        total_amount: "",
        out_trade_no: "",
        pay_type: "alipay",
        code: "",
        user_id: "",
        per_month: "",
        remark: "",
        mp_token: "",
        show_amount: "",
        addr_name: "",
        addr_phone: "",
        addr_address: "",

        sku_detail: [],
        plan_invite_code: "",
        custom_order_id:'',

        cmid:'',
        card_id_list:[],
        ticket_round_id:'',

        agreement:'',
    },
};

//订单支付状态查询
export const POST_ORDER_CHECK = {
  name: "POST_ORDER_CHECK",
  url: "/api/order/check",
  method: "get",
  data: { out_trade_no: "" },
};
//paypal 订单支付状态查询
export const POST_PAYPAL_CAPTURE = {
  name: "POST_PAYPAL_CAPTURE",
  url: "/api/paypal/capture",
  method: "get",
  data: { out_trade_no: "", token:'', PayerID:'' },
};

//新增签到接口
export const GET_ORDER_SIGN = {
    name: "GET_ORDER_SIGN",
    url: "/api/order/sign",
    method: "get",
    data: { out_trade_no: "" },
};

//获取我的账单
export const GET_MY_BILL_HISTORY = {
    name: "GET_MY_BILL_HISTORY",
    url: "/api/my/bill-history",
    method: "get",
    data: {},
};

//取消订单
export const GET_ORDER_CANCEL = {
    name: "GET_ORDER_CANCEL",
    url: "/api/order/cancel-order",
    method: "post",
    data: { out_trade_no: "" },
};

//创作者列表
export const GET_CREATOR_LIST = {
    name: "GET_CREATOR_LIST",
    url: "/api/creator/list",
    method: "get",
    data: { page: 1, type: "", category_id: "", q: "" }, //'rec' 'hot' 'new'
};

//管理面板
export const GET_MY_DASHBOARD = {
    name: "GET_MY_DASHBOARD",
    url: "/api/my/dashboard",
    method: "get",
    data: {},
};

//赞助过我的人
export const GET_MY_SPONSORED_HISTORY = {
    name: "GET_MY_SPONSORED_HISTORY",
    url: "/api/my/sponsored-history",
    method: "get",
    data: { page: 1 },
};

//提现历史记录
export const GET_MY_WITHDRAW_HISTORY = {
    name: "GET_MY_WITHDRAW_HISTORY",
    url: "/api/my/withdraw-history",
    method: "get",
    data: {},
};

//提现
export const GET_MY_APPLY_WITHDRAW = {
    name: "GET_MY_APPLY_WITHDRAW",
    url: "/api/my/apply-withdraw",
    method: "post",
    data: {},
};

//个人设置
export const POST_MY_EDIT_BASIC = {
    name: "POST_MY_EDIT_BASIC",
    url: "/api/my/edit-basic",
    method: "post",
    data: {
        avatar: "",
        name: "",
        addr_name: "",
        addr_phone: "",
        addr_address: "",
    },
};

//这个人赞助的用户
export const GET_USER_SPONSORING = {
    name: "GET_USER_SPONSORING",
    url: "/api/user/get-sponsoring",
    method: "get",
    data: { user_id: "" },
};

//对话列表
export const GET_MESSAGE_DIALOGS = {
    name: "GET_MESSAGE_DIALOGS",
    url: "/api/message/dialogs",
    method: "get",
    data: { page: 1, unread:''},
};

//私信内容
export const GET_MESSAGE_MESSAGES = {
    name: "GET_MESSAGE_MESSAGES",
    url: "/api/message/messages",
    method: "get",
    data: { user_id: "", type: "old", message_id: "" },
};

//send 私信
export const POST_MESSAGE_SEND = {
    name: "POST_MESSAGE_SEND",
    url: "/api/message/send",
    method: "post",
    data: { user_id: "", type: "", content: "" },
};

//是否可以 send 私信
export const GET_MESSAGE_CAN_SEND = {
    name: "GET_MESSAGE_CAN_SEND",
    url: "/api/message/can-send",
    method: "get",
    data: { user_id: "" },
};

//轮询 check
export const GET_MY_CHECK = {
    name: "GET_MY_CHECK",
    url: "/api/my/check",
    method: "get",
    data: {},
};

//获取 notice-bar
export const GET_MY_NOTICE_BAR = {
    name: "GET_MY_NOTICE_BAR",
    url: "/api/my/notice-bar",
    method: "get",
    data: {},
};

//获取和对方的赞助关系  ||  查询某个赞助详情
export const GET_USER_SPONSOR_INFO = {
    name: "GET_USER_SPONSOR_INFO",
    url: "/api/user/sponsor-info",
    method: "get",
    data: { user_id: "" },
};

//获取赞助订单
export const GET_MY_SPONSORED_BILL = {
    name: "GET_MY_SPONSORED_BILL",
    url: "/api/my/sponsored-bill",
    method: "get",
    data: { pay_success_sn: "", type: "old" },
};

//获取赞助订单 v2
export const GET_MY_SPONSORED_BILL_FILTER = {
    name: "GET_MY_SPONSORED_BILL_FILTER",
    url: "/api/my/sponsored-bill-filter",
    method: "get",
    data: {
        page: 1,
        sort_field: "update_time",
        sort_value: "desc",
        is_redeem: 0,
        plan_id: "",
        sign_status: 0,
        has_remark:0,
        // has_address:0,
        status:'',
        order_id:'',
        nick_name:'',
        remark:'',
        express_no:'',
    },
};

//获取微信下单地址
export const GET_ORDER_WXJSURL = {
    name: "GET_ORDER_WXJSURL",
    url: "/api/order/wxjsurl",
    method: "get",
    data: { url: "" },
};

//发布feed内容
export const POST_POST_PUBLISH = {
    name: "POST_POST_PUBLISH",
    url: "/api/post/publish",
    method: "post",
    data: {
        post_id: "",
        vote_id: "",
        cate: "",
        title: "",
        content: "",
        pics: "",
        is_public: "",
        min_price: "",
        audio: "",
        video: "",
        audio_thumb: "",
        video_thumb: "",
        type: 0,
        cover: "",
        group_id: "",
        is_feed: 0,
        plan_ids: "",
        album_ids: "",
        attachment: [],
        timing:'',
        optype:'publish', // publish  || draft  || timing
        preview_text:'',
        cover:'',
    },
};

//删除feed内容
export const POST_POST_DELETE = {
    name: "POST_POST_DELETE",
    url: "/api/post/delete",
    method: "post",
    data: { post_id: "" },
};
//删除动态，不影响作品集
export const POST_CREATOR_REM_ALBUM_POST = {
    name: "POST_CREATOR_REM_ALBUM_POST",
    url: "/api/creator/rem-album-post",
    method: "post",
    data: { post_id: "", album_id: "" },
};

//获取 post
export const GET_POST_LIST = {
    name: "GET_POST_LIST",
    url: "/api/post/get-list",
    method: "get",
    data: {
        user_id: "",
        type: "old",
        publish_sn: "",
        per_page: 10,
        group_id: "",
        all:'',
        is_public:'',
        plan_id:'',
        title:'',
        name:'',
    },
};

//post like
export const POST_POST_LIKE = {
    name: "POST_POST_LIKE",
    url: "/api/post/like",
    method: "post",
    data: { post_id: "" },
};

//post unlike
export const POST_POST_UNLIKE = {
    name: "POST_POST_UNLIKE",
    url: "/api/post/unlike",
    method: "post",
    data: { post_id: "" },
};

//comment like
export const POST_COMMENT_LIKE = {
    name: "POST_COMMENT_LIKE",
    url: "/api/comment/like",
    method: "post",
    data: { comment_id: "" },
};

//comment unlike
export const POST_COMMENT_UNLIKE = {
    name: "POST_COMMENT_UNLIKE",
    url: "/api/comment/unlike",
    method: "post",
    data: { comment_id: "" },
};

// 切换自选方案的状态
export const POST_CREATOR_CUSTOM_PLAN_SWITCH = {
    name: "POST_CREATOR_CUSTOM_PLAN_SWITCH",
    url: "/api/creator/custom-plan-switch",
    method: "post",
    data: { status: "", desc: "" }, //1 || 2 || 3
};

// 隐藏计划方案的状态
export const POST_CREATOR_HIDE_PLAN = {
    name: "POST_CREATOR_HIDE_PLAN",
    url: "/api/creator/hide-plan",
    method: "post",
    data: { plan_id: "" },
};

// 展示计划方案的状态
export const POST_CREATOR_SHOW_PLAN = {
    name: "POST_CREATOR_SHOW_PLAN",
    url: "/api/creator/show-plan",
    method: "post",
    data: { plan_id: "" },
};

// 获取某条post详情
export const GET_POST_GET_DETAIL = {
    name: "GET_POST_GET_DETAIL",
    url: "/api/post/get-detail",
    method: "get",
    data: { post_id: "", album_id: "" },
};

// 获取某条post 的评论list
export const GET_COMMENT_GET_LIST = {
    name: "GET_COMMENT_GET_LIST",
    url: "/api/comment/get-list",
    method: "get",
    data: { post_id: "", publish_sn: "", type: "old", hot: "" },
};

// 发布评论、回复
export const POST_COMMENT_PUBLISH = {
    name: "POST_COMMENT_PUBLISH",
    url: "/api/comment/publish",
    method: "post",
    data: { post_id: "", content: "", reply_comment_id: "" },
};

// 获取赞助排行榜
export const GET_CREATOR_GET_TOP_SPONSORS = {
    name: "GET_CREATOR_GET_TOP_SPONSORS",
    url: "/api/creator/get-top-sponsors",
    method: "get",
    data: { user_id: "" },
};

// 获取赞助列表
export const GET_CREATOR_GET_SPONSORS = {
    name: "GET_CREATOR_GET_SPONSORS",
    url: "/api/creator/get-sponsors",
    method: "get",
    data: { user_id: "", type: "", page: "" }, //type : new || amount
};

// 获取某年某月 赞助列表
export const GET_CREATOR_GET_THANK_SPONSORS = {
    name: "GET_CREATOR_GET_THANK_SPONSORS",
    url: "/api/creator/get-thank-sponsors",
    method: "get",
    data: { user_id: "", month: "", year: "", page: 1 },
};

// 获取感谢语
export const GET_CREATOR_GET_THANK_WORD = {
    name: "GET_CREATOR_GET_THANK_WORD",
    url: "/api/creator/get-thank-word",
    method: "get",
    data: { user_id: "", month: "", year: "" },
};

// 编辑感谢语
export const POST_CREATOR_EDIT_THANK_WORD = {
    name: "POST_CREATOR_EDIT_THANK_WORD",
    url: "/api/creator/edit-thank-word",
    method: "post",
    data: { content: "", month: "", year: "", pic: "" },
};

//获取所有赞助方案
export const GET_ALL_GOALS = {
    name: "GET_ALL_GOALS",
    url: "/api/creator/all-goals",
    method: "get",
    data: {},
};

//获取他人所有赞助方案
export const GET_CREATOR_GOALS = {
    name: "GET_CREATOR_GOALS",
    url: "/api/creator/get-goals",
    method: "get",
    data: { user_id: "" },
};

//新增或编辑单个目标
export const POST_EDIT_GOAL = {
    name: "POST_EDIT_GOAL",
    url: "/api/creator/edit-goal",
    method: "post",
    data: {
        goal_id: "",
        monthly_fans: "",
        monthly_income: "",
        desc: "",
        type: 1,
        status: 1,
        begin_time:'',
        end_time:'',
    },
};

//删除目标
export const POST_DEL_GOAL = {
    name: "POST_DEL_GOAL",
    url: "/api/creator/delete-goal",
    method: "post",
    data: { goal_id: "" },
};

// 隐藏目标的状态
export const POST_CREATOR_HIDE_GOAL = {
    name: "POST_CREATOR_HIDE_GOAL",
    url: "/api/creator/hide-goal",
    method: "post",
    data: { goal_id: "" },
};

// 展示目标方案的状态
export const POST_CREATOR_SHOW_GOAL = {
    name: "POST_CREATOR_SHOW_GOAL",
    url: "/api/creator/show-goal",
    method: "post",
    data: { goal_id: "" },
};

// 公共feed
export const GET_REC_LIST = {
    name: "GET_REC_LIST",
    url: "/api/post/get-rec-list",
    method: "get",
    data: { publish_sn: "", type: "old", all:'' },
};

// 我发电的 feed
export const GET_MY_REC_LIST = {
    name: "GET_MY_REC_LIST",
    url: "/api/post/get-my-rec-list",
    method: "get",
    data: { publish_sn: "", type: "old", all:'' },
};

// 获取我的赞助
export const GET_MY_SPONSORING = {
    name: "GET_MY_SPONSORING",
    url: "/api/my/sponsoring",
    method: "get",
    data: { need_sponsor_info: "" },
};

// 绑定手机、邮箱验证码
export const POST_ACCOUNT_SEND_VERIFY_CODE = {
    name: "POST_ACCOUNT_SEND_VERIFY_CODE",
    url: "/api/account/send-verify-code",
    method: "post",
    data: { account: "" },
};

// 修改密码
export const POST_ACCOUNT_CHANGE_PASSWORD = {
    name: "POST_ACCOUNT_CHANGE_PASSWORD",
    url: "/api/account/change-password",
    method: "post",
    data: { old_password: "", new_password: "" },
};

// 绑定
export const POST_ACCOUNT_BIND = {
    name: "POST_ACCOUNT_BIND",
    url: "/api/account/bind",
    method: "post",
    data: { account: "", code: "" },
};

// 获取绑定信息
export const GET_MY_ACCOUNT = {
    name: "GET_MY_ACCOUNT",
    url: "/api/my/account",
    method: "get",
    data: {},
};

//获取 任务todo
export const GET_MY_CREATOR_ACCOMPLISHMENT = {
    name: "GET_MY_CREATOR_ACCOMPLISHMENT",
    url: "/api/my/creator-accomplishment",
    method: "get",
    data: {},
};

// 完成 分享todo
export const POST_MY_CREATOR_SHARE_PAGE = {
    name: "POST_MY_CREATOR_SHARE_PAGE",
    url: "/api/my/creator-share-page",
    method: "post",
    data: {},
};

// 获取 微信登录授权第一步 redirect_uri
export const POST_OAUTH_MP_REDIRECT_URI = {
    name: "POST_OAUTH_MP_REDIRECT_URI",
    url: "/api/oauth/mp-redirect-uri",
    method: "post",
    data: { redirect_uri: "" },
};

// 获取 微信登录授权第二步 mp_token
export const POST_OAUTH_MP_CODE = {
    name: "POST_OAUTH_MP_CODE",
    url: "/api/oauth/mp-code",
    method: "post",
    data: { code: "" },
};


// 获取 PC微信登录授权第一步 redirect_uri
export const POST_OAUTH_MX_REDIRECT_URI = {
    name: "POST_OAUTH_MX_REDIRECT_URI",
    url: "/api/oauth/wx-redirect-uri",
    method: "post",
    data: { redirect_uri: "" },
};

// 获取 PC微信登录授权第二步 mx_token
export const POST_OAUTH_MX_CODE = {
    name: "POST_OAUTH_MX_CODE",
    url: "/api/oauth/wx-code",
    method: "post",
    data: { code: "" },
};

// 设置是否开启折扣
export const POST_CREATOR_DISCOUNT_OPTION = {
    name: "POST_CREATOR_DISCOUNT_OPTION",
    url: "/api/creator/discount-option",
    method: "post",
    data: { status: "" },
};

// 获取视频第一帧图片
export const GET_UPLOAD_SNAPSHOT = {
    name: "GET_UPLOAD_SNAPSHOT ",
    url: "/api/upload/snapshot",
    method: "get",
    data: { snapshot_id: "" },
};

// 删除评论
export const POST_COMMENT_DELETE = {
    name: "POST_COMMENT_DELETE ",
    url: "/api/comment/delete",
    method: "post",
    data: { comment_id: "" },
};

// 是否展示指南
export const POST_CREATOR_SHOW_GUIDE = {
    name: "POST_CREATOR_SHOW_GUIDE ",
    url: "/api/creator/show-guide",
    method: "post",
    data: { status: "" },
};

// 是否展示收入
export const POST_CREATOR_PRIVACY_PUBLIC_INCOME = {
    name: "POST_CREATOR_PRIVACY_PUBLIC_INCOME ",
    url: "/api/creator/privacy-public-income",
    method: "post",
    data: { status: "" },
};
// 是否展示赞助人数
export const POST_CREATOR_PRIVACY_PUBLIC_SPONSOR = {
    name: "POST_CREATOR_PRIVACY_PUBLIC_SPONSOR ",
    url: "/api/creator/privacy-public-sponsor",
    method: "post",
    data: { status: "" },
};

// 我的通知
export const POST_MY_NOTICE = {
    name: "POST_MY_NOTICE",
    url: "/api/my/notice",
    method: "get",
    data: { publish_sn: "", type: "old", action: "" },
};

// 赞助数据
export const GET_MY_STATS = {
    name: "GET_MY_STATS",
    url: "/api/my/stats",
    method: "get",
    data: {},
};

// 每月收入
export const GET_MY_INCOME = {
    name: "GET_MY_INCOME",
    url: "/api/my/income",
    method: "get",
    data: {},
};

// 置顶
export const POST_TOP = {
    name: "POST_TOP",
    url: "/api/post/top",
    method: "post",
    data: { post_id: "" },
};

// 取消置顶
export const POST_UNTOP = {
    name: "POST_UNTOP",
    url: "/api/post/untop",
    method: "post",
    data: { post_id: "" },
};

// 新增、编辑作品集
export const POST_CREATOR_EDIT_ALBUM = {
    name: "POST_CREATOR_EDIT_ALBUM",
    url: "/api/creator/edit-album",
    method: "post",
    data: { album_id: "", title: "", content: "", cover: "" },
};

// // 新增、编辑作品集含动态    统一接口
// export const GET_CREATOR_EDIT_ALBUM_AND_POST = {
//     name: "GET_CREATOR_EDIT_ALBUM_AND_POST",
//     url: "/api/creator/edit-album-and-post",
//     method: "post",
//     data: { album_id: "", title: "", content: "", cover: "", post_ids: "" }
// };

// 获取作品集 信息
export const GET_CREATOR_GET_ALBUM_INFO = {
    name: "GET_CREATOR_GET_ALBUM_INFO",
    url: "/api/user/get-album-info",
    method: "get",
    data: { album_id: "" },
};

// 保存对应的动态id
export const POST_CREATOR_EDIT_ALBUM_POST = {
    name: "POST_CREATOR_EDIT_ALBUM_POST",
    url: "/api/creator/edit-album-post",
    method: "post",
    data: { album_id: "", post_ids: "" },
};

// 获取 album 列表
export const GET_CREATOR_GET_ALBUM_LIST = {
    name: "GET_CREATOR_GET_ALBUM_LIST",
    url: "/api/user/get-album-list",
    method: "get",
    data: { user_id: "", page: "", per_page: ''},
};

// 获取 album 动态列表
export const GET_CREATOR_GET_ALBUM_POST = {
    name: "GET_CREATOR_GET_ALBUM_POST",
    url: "/api/user/get-album-post",
    method: "get",
    data: { album_id: "", lastRank: "", rankOrder: "", rankField:'' },
};

// 设置作品集排序
export const POST_CREATOR_UPDATE_ALBUM_POST_ORDER_BY = {
    name: "POST_CREATOR_UPDATE_ALBUM_POST_ORDER_BY",
    url: " /api/creator/update-album-post-order-by",
    method: "post",
    data: { album_id: "", order_by: "" },
};


// 获取 album posr_ids 列表
export const GET_CREATOR_GET_ALBUM_POST_IDS = {
    name: "GET_CREATOR_GET_ALBUM_POST_IDS",
    url: " /api/creator/get-album-post-ids",
    method: "get",
    data: { album_id: "" },
};

// 删除 album
export const GET_CREATOR_DEL_ALBUM = {
    name: "GET_CREATOR_DEL_ALBUM",
    url: "/api/creator/del-album",
    method: "post",
    data: { album_id: "" },
};

// 获取 目录
export const GET_CREATOR_GET_ALBUM_CATALOG = {
    name: "GET_CREATOR_GET_ALBUM_CATALOG",
    url: "/api/user/get-album-catalog",
    method: "get",
    data: { album_id: "",page: 1,per_page: 10 },
};

// 设置是否展示 作品集
export const POST_CREATOR_SHOW_ALBUM = {
    name: "POST_CREATOR_SHOW_ALBUM",
    url: "/api/creator/show-album",
    method: "post",
    data: { status: "" },
};

// 设置是否展示 电铺
export const POST_CREATOR_SHOW_SHOP = {
    name: "POST_CREATOR_SHOW_SHOP",
    url: "/api/creator/show-shop",
    method: "post",
    data: { status: "" },
};

// 【创作者】创作者新增、编辑电圈
export const GET_CREATOR_EDIT_GROUP = {
    name: "GET_CREATOR_EDIT_GROUP",
    url: "/api/creator/edit-group",
    method: "post",
    data: {
        group_id: "",
        title: "",
        content: "",
        cover: "",
        type: "",
        price: "",
        join_group_type:'',
        selected_plan:''
    },
};

// 电圈主页
export const GET_USER_GET_GROUP = {
  name: "GET_USER_GET_GROUP",
  url: "/api/user/get-group",
  method: "get",
  data: {
      group_id: "",
  },
};
// 获取关联电圈的plan 
export const GET_GROUP_SELECTED_PLANS = {
    name: "GET_GROUP_SELECTED_PLANS",
    url: "/api/creator/get-group-selected-plans",
    method: "get",
    data: {},
};

// 电圈动态
export const GET_USER_GET_GROUP_FEED = {
    name: "GET_USER_GET_GROUP_FEED",
    url: "/api/user/get-group-feed",
    method: "get",
    data: {
        group_id: "",
        filter: "all",
        publish_sn: "",
    },
};

// 创作者个人主页-增加创建的电圈
export const GET_CREATOR_GET_GROUP_STATUS = {
    name: "GET_CREATOR_GET_GROUP_STATUS",
    url: "/api/creator/get-group-status",
    method: "get",
    data: {},
};

// 个人主页展示他的电圈（用户侧）
export const GET_USER_GET_GROUP_LIST = {
    name: "GET_USER_GET_GROUP_LIST",
    url: "/api/user/get-group-list",
    method: "get",
    data: { user_id: "" },
};

// 主动加入电圈
export const GET_USER_JOIN_GROUP = {
    name: "GET_USER_JOIN_GROUP",
    url: "/api/user/join-group",
    method: "post",
    data: { group_id: "" },
};

// 首页-展示已经加入的电圈（用户侧）
export const GET_MY_JOINED_GROUP = {
    name: "GET_MY_JOINED_GROUP",
    url: "/api/my/joined-group",
    method: "get",
    data: {},
};

// 【创作者】编辑电圈开放状态
export const POST_CREATOR_OPEN_GROUP_SWITCH = {
    name: "POST_CREATOR_OPEN_GROUP_SWITCH",
    url: "/api/creator/open-group-switch",
    method: "post",
    data: {
        group_id: "",
        status: "",
    },
};

// 电圈内动态置顶
export const POST_POST_TOP_GROUP = {
    name: "POST_POST_TOP_GROUP",
    url: "/api/post/top-group",
    method: "post",
    data: {
        post_id: "",
    },
};

// 取消置顶
export const POST_POST_UNTOP_GROUP = {
    name: "POST_POST_UNTOP_GROUP",
    url: "/api/post/untop-group",
    method: "post",
    data: {
        post_id: "",
    },
};

// 获取签名
export const POST_UPLOAD_GET_SIGN = {
    name: "POST_UPLOAD_GET_SIGN",
    url: "/api/upload/get-sign",
    method: "post",
    data: {type:''},
};

// 获取 web 上传的 url
export const POST_UPLOAD_GET_URL = {
    name: "POST_UPLOAD_GET_URL",
    url: "/api/upload/get-url",
    method: "post",
    data: { url: "",type:'' },
};

// 【创作者】生成兑换码
export const POST_CREATOR_MAKE_REDEEM = {
    name: "POST_CREATOR_MAKE_REDEEM",
    url: "/api/creator/make-redeem",
    method: "post",
    data: { plan_id: "", num: "",sku_id:'' },
};

// 【创作者】获取历史兑换码
export const GET_CREATOR_REDEEM_HISTORY = {
    name: "GET_CREATOR_REDEEM_HISTORY",
    url: "/api/creator/redeem-history",
    method: "get",
    data: { plan_id: "",sku_id:'' },
};

// 获取兑换码详情
export const GET_USER_REDEEM_INFO = {
    name: "GET_USER_REDEEM_INFO",
    url: "/api/user/redeem-info",
    method: "get",
    data: { redeem_id: "" },
};

// 使用兑换码
export const POST_USER_USE_REDEEM = {
    name: "POST_USER_USE_REDEEM",
    url: "/api/user/use-redeem",
    method: "post",
    data: { redeem_id: "", addr_name :'', addr_phone:'', addr_address:'' },
};

// cloud 服务临时密钥
export const GET_UPLOAD_GET_OBJ_SIGN = {
    name: "GET_UPLOAD_GET_OBJ_SIGN",
    url: "/api/upload/get-obj-sign",
    method: "get",
    data: {},
};

// 设置隐藏方案是否可以购买
export const POST_SET_CAN_BUY_HIDE = {
    name: "POST_SET_CAN_BUY_HIDE",
    url: "/api/creator/set-can-buy-hide",
    method: "post",
    data: { plan_id: "", status: "" },
};

// 我收藏的创作者
export const GET_MY_MARKED = {
    name: "GET_MY_MARKED",
    url: "/api/my/marked",
    method: "get",
    data: {},
};
// 我收藏的动态
export const GET_MY_MARKED_POST = {
    name: "GET_MY_MARKED_POST",
    url: "/api/my/marked-post",
    method: "get",
    data: {page:''},
};
// 收藏某人
export const POST_USER_MARK = {
    name: "POST_USER_MARK",
    url: "/api/user/mark",
    method: "post",
    data: { user_id: "" },
};

// 取消收藏某人
export const POST_USER_UNMARK = {
    name: "POST_USER_UNMARK",
    url: "/api/user/unmark",
    method: "post",
    data: { user_id: "" },
};

// 获取售卖信息，SKU列表
export const POST_GET_PLAN_SKUS = {
    name: "POST_GET_PLAN_SKUS",
    url: "/api/creator/get-plan-skus",
    method: "get",
    data: { plan_id: "", is_ext: ''},  //is_ext: 1 需要始终传限时信息
};

// 商品订单接口  wait delete
export const GET_MY_PRODUCT_ORDER = {
    name: "GET_MY_PRODUCT_ORDER",
    url: "/api/my/product-order",
    method: "get",
    data: { },
};

// 订单用新接口
export const GET_MY_SPONSORED_BILL_OUT_FILTER = {
    name: "GET_MY_SPONSORED_BILL_OUT_FILTER",
    url: "/api/my/sponsored-bill-out-filter",
    method: "get",
    data: { page:1, sort_field:'',sort_value:'',is_redeem: 0,plan_id:'',sign_status:'',status:''},
};

// 退出电圈
export const POST_USER_QUIT_GROUP = {
    name: "POST_USER_QUIT_GROUP",
    url: "/api/user/quit-group",
    method: "post",
    data: { group_id:'' },
};

// 检查认证状态
export const GET_CREATOR_CHECK_CERTIFICATION = {
    name: "GET_CREATOR_CHECK_CERTIFICATION",
    url: "/api/creator/check-certification",
    method: "get",
    data: { },
};

// 认证
export const POST_CREATOR_SUBMIT_CERTIFICATION = {
    name: "POST_CREATOR_SUBMIT_CERTIFICATION",
    url: "/api/creator/submit-certification",
    method: "post",
    data: { url: '' },
};

// 版权保护 文字
export const POST_CREATOR_COPY_TEXT = {
    name: "POST_CREATOR_COPY_TEXT",
    url: "/api/creator/copy-text",
    method: "post",
    data: { status: '' },
};

// 版权保护 图片
export const POST_CREATOR_COPY_PIC = {
    name: "POST_CREATOR_COPY_PIC",
    url: "/api/creator/copy-pic",
    method: "post",
    data: { status: '' },
};

// 首页分类
export const GET_WELCOME_CATEGORY_LIST = {
    name: "GET_WELCOME_CATEGORY_LIST",
    url: "/api/welcome/category-list",
    method: "get",
    data: { },
};

// 首页某分类 list
export const GET_WELCOME_CATEGORY_CREATOR = {
    name: "GET_WELCOME_CATEGORY_CREATOR",
    url: "/api/welcome/category-creator",
    method: "get",
    data: { category_id: ''},
};

// 拒绝、屏蔽
export const POST_API_USER_BLACK = {
    name: "POST_API_USER_BLACK",
    url: "/api/user/black",
    method: "post",
    data: { user_id: '', type: ''},
};

// 解开拒绝、解开屏蔽
export const POST_API_USER_UNBLACK = {
    name: "POST_API_USER_UNBLACK",
    url: "/api/user/unblack",
    method: "post",
    data: { user_id: '', type: ''},
};

// 拒绝列表、屏蔽列表
export const GET_API_MY_BLACKED = {
    name: "GET_API_MY_BLACKED",
    url: "/api/my/blacked",
    method: "get",
    data: { page: 1, type: ''},
};

// 展示我发电的 开关
export const POST_USER_SHOW_SPONSORING = {
    name: "POST_USER_SHOW_SPONSORING",
    url: "/api/user/show-sponsoring",
    method: "post",
    data: { status: ''},
};

// Qa列表
export const GET_API_FAQ_LIST_FAQ = {
    name: "GET_API_FAQ_LIST_FAQ",
    url: "/api/faq/list-faq",
    method: "get",
    data: { user_id:''},
};

// 发送 qa 问题
export const POST_API_FAQ_ASK = {
    name: "POST_API_FAQ_ASK",
    url: "/api/faq/ask",
    method: "post",
    data: { id:'', user_id:''},
};

// 发送 qa 回复
export const POST_API_FAQ_ANSWER = {
    name: "POST_API_FAQ_ANSWER",
    url: "/api/faq/answer",
    method: "post",
    data: { id:'', user_id:''},
};

// 快递列表/api/order/update-express
export const GET_ORDER_EXPRESS_COMPANY_LIST = {
    name: "GET_ORDER_EXPRESS_COMPANY_LIST",
    url: "/api/order/express-company-list",
    method: "get",
    data: {},
};


// 设置快递
export const POST_ORDER_UPDATE_EXPRESS = {
    name: "POST_ORDER_UPDATE_EXPRESS",
    url: "/api/order/update-express",
    method: "post",
    data: {out_trade_no:'',company_id:'',express_no:''},
};

// 设置收件信息
export const POST_ORDER_UPDATE_ADDRESS = {
    name: "POST_ORDER_UPDATE_ADDRESS",
    url: "/api/order/update-address",
    method: "post",
    data: {out_trade_no:'', addr_name :'', addr_phone:'', addr_address:''},
};

// 创作者统计
export const GET_MY_STAT = {
    name: "GET_MY_STAT",
    url: "/api/my/stat",
    method: "get",
    data: {page:1,type:'day',}, //day week month
};

// 赞助我的人   https://gitee.com/-/ide/project/wegreate/wiki/edit/master/-/%E8%B5%9E%E5%8A%A9%E6%88%91%E7%9A%84%E4%BA%BA.MD
export const POST_MY_WHO_SPONSORED_ME = {
    name: "POST_MY_WHO_SPONSORED_ME",
    url: "/api/my/who-sponsored-me",
    method: "post",
    data: {page:1,sort_field:'',sort_value:'',filter:[],per_page:10},
};

// 群发私信检查接口
export const POST_MY_CHECK_SEND_MSG_BATCH = {
    name: "POST_MY_CHECK_SEND_MSG_BATCH",
    url: "/api/my/check-send-msg-batch",
    method: "post",
    data: {filter:[], is_all: 0, include_user_ids: [], exclude_user_ids: [],type:'text', content:''},
};

// 群发私信接口
export const POST_MY_SEND_MSG_BATCH = {
    name: "POST_MY_SEND_MSG_BATCH",
    url: "/api/my/send-msg-batch",
    method: "post",
    data: {filter:[], is_all: 0, include_user_ids: [], exclude_user_ids: [],type:'text', content:''},
};

// 检查私信任务进度
export const POST_MY_SEND_MSG_BATCH_PROGRESS = {
    name: "POST_MY_SEND_MSG_BATCH_PROGRESS",
    url: "/api/my/send-msg-batch-progress",
    method: "get",
    data: {task_id:''},
};

// 获取 token
export const POST_CREATOR_LIST_OPEN_TOKENS = {
    name: "POST_CREATOR_LIST_OPEN_TOKENS",
    url: "/api/creator/list-open-tokens",
    method: "get",
    data: {},
};

// 创建开放 token
export const POST_CREATOR_CREATE_OPEN_TOKEN = {
    name: "POST_CREATOR_CREATE_OPEN_TOKEN",
    url: "/api/creator/create-open-token",
    method: "post",
    data: {},
};

// 获取webhook地址
export const GET_CREATOR_LIST_OPEN_WEBHOOK = {
    name: "GET_CREATOR_LIST_OPEN_WEBHOOK",
    url: "/api/creator/list-open-webhook",
    method: "get",
    data: {},
};

// 更新webhook地址
export const POST_CREATOR_UPDATE_OPEN_WEBHOOK = {
    name: "POST_CREATOR_UPDATE_OPEN_WEBHOOK",
    url: "/api/creator/update-open-webhook",
    method: "post",
    data: {url:''},
};

// 测试webhook地址
export const POST_CREATOR_TEST_OPEN_WEBHOOK = {
    name: "POST_CREATOR_TEST_OPEN_WEBHOOK",
    url: "/api/creator/test-open-webhook",
    method: "post",
    data: {url:''},
};

// 新增投票接口
export const POST_EDIT_VOTE = {
    name: "POST_EDIT_VOTE",
    url: "/api/post/edit-vote",
    method: "post",
    data: { vote_id:"", chosen_type: '', chosen_max: '', title: "", deadline: 0, options: [],deadline_type:''},
};

// 查询投票接口
export const GET_GET_VOTE = {
    name: "GET_GET_VOTE",
    url: "/api/post/get-vote",
    method: "get",
    data: {vote_id:''},
};

// 投票接口
export const POST_CAST_VOTE = {
    name: "POST_CAST_VOTE",
    url: "/api/post/cast-vote",
    method: "post",
    data: {vote_id:'', vote:[] },
};

// 获取工单类型接口
export const GET_MESSAGE_WORK_ORDER_OPTIONS = {
    name: "GET_MESSAGE_WORK_ORDER_OPTIONS",
    url: "/api/message/work-order-options",
    method: "get",
    data: { },
};

// 创建工单接口
export const POST_MESSAGE_CREATE_WORK_ORDER = {
    name: "POST_MESSAGE_CREATE_WORK_ORDER",
    url: "/api/message/create-work-order",
    method: "post",
    data: { msg_id: '', type: ''},
};


// 查询物流
export const GET_ORDER_QUERY_EXPRESS_PROGRESS = {
    name: "GET_ORDER_QUERY_EXPRESS_PROGRESS",
    url: "/api/order/query-express-progress",
    method: "get",
    data: { number: '', mobile: '',out_trade_no:''},
};

// wx-jssdk-sign
export const GET_OAUTH_JSSDK_SIGN = {
    name: "GET_OAUTH_JSSDK_SIGN",
    url: "/api/oauth/jssdk-sign",
    method: "post",
    data: { url: ''},
};

// 解绑微信
export const GET_ACCOUNT_UNBIND_WECHAT = {
    name: "GET_ACCOUNT_UNBIND_WECHAT",
    url: "/api/account/unbind-wechat",
    method: "get",
    data: { },
};

// 电铺列表
export const GET_PRODUCTS = {
    name: "GET_PRODUCTS",
    url: "/api/creator/get-products",
    method: "get",
    data: { user_id:'', page:''},
};
// 数字内容获取
export const GET_SKU = {
    name: "GET_SKU",
    url: "/api/creator/get-sku",
    method: "get",
    data: { sku_id:''},
};

// 收藏
export const POST_USER_MARK_POST = {
    name: "POST_USER_MARK_POST",
    url: "/api/user/mark-post",
    method: "post",
    data: { post_id:''},
};

// 取消收藏
export const POST_USER_UNMARK_POST = {
    name: "POST_USER_UNMARK_POST",
    url: "/api/user/unmark-post",
    method: "post",
    data: { post_id:''},
};

// 用户筛选feed 设置
export const POST_UPDATE_USER_FEED_SETTING = {
    name: "POST_UPDATE_USER_FEED_SETTING",
    url: "/api/post/update-user-feed-setting",
    method: "post",
    data: { sponsoring:'',unlock:'',in_blacklist:'', user_id:''},
};

// 获取被屏蔽的创作者列表
export const GET_BLOCKED_CREATORS = {
    name: "GET_BLOCKED_CREATORS",
    url: "/api/post/get-blocked-creators",
    method: "get",
    data: { },
};

// 修改普通订阅是否计入统计
export const POST_GOAL_SETTING_SPONSOR = {
    name: "POST_GOAL_SETTING_SPONSOR",
    url: "/api/creator/goal-setting-sponsor",
    method: "post",
    data: { status: ''},
};

// 修改售卖是否计入统计
export const POST_GOAL_SETTING_PRODUCT = {
    name: "POST_GOAL_SETTING_PRODUCT",
    url: "/api/creator/goal-setting-product",
    method: "post",
    data: {status: '' },
};

// 获取通知配置
export const GET_MY_NOTIFY_CONFIG = {
    name: "GET_MY_NOTIFY_CONFIG",
    url: "/api/my/notify-config",
    method: "get",
    data: {},
};

// 修改通知配置
export const POST_MY_UPDATE_NOTIFY = {
    name: "POST_MY_UPDATE_NOTIFY",
    url: "/api/my/update-notify",
    method: "post",
    data: {status:'',field:''},
};

// 设置主页商品显示数量
export const POST_SHOW_PRODUCT_COUNT_SET = {
    name: "POST_SHOW_PRODUCT_COUNT_SET",
    url: "/api/creator/show-product-count-set",
    method: "post",
    data: {count:''},
};

// 获取订单收发货数量
export const GET_SPONSORED_BILL_OUT_COUNT = {
    name: "GET_SPONSORED_BILL_OUT_COUNT",
    url: "/api/my/sponsored-bill-out-count",
    method: "get",
    data: {},
};

// 获取验证码接口 
export const GET_BANG_SMS_CODE = {
    name: "GET_BANG_SMS_CODE",
    url: "/api/bang/sms-code",
    method: "get",
    data: {mobile_number:''},
};

// 搜索银行编码 
export const GET_BANG_SEARCH_BANK = {
    name: "GET_BANG_SEARCH_BANK",
    url: "/api/bang/search-bank",
    method: "get",
    data: {name:''},
};

// 搜索联行号  
export const GET_BANG_SEARCH_BRANCH_BANK = {
    name: "GET_BANG_SEARCH_BRANCH_BANK",
    url: "/api/bang/search-branch-bank",
    method: "get",
    data: {name:''},
};

// 搜索开户行所在地  
export const GET_BANG_SEARCH_CITY = {
  name: "GET_BANG_SEARCH_CITY",
  url: "/api/bang/search-city",
  method: "get",
  data: {name:''},
};

// 搜索用户的feed or 商品 
export const POST_API_CREATOR_SEARCH = {
  name: "POST_API_CREATOR_SEARCH",
  url: "/api/creator/search",
  method: "post",
  data: {user_id:'', keyword:'', type:'', page:1},
};

// 认证 
export const POST_BANG_CUS_APPLICATION = {
  name: "POST_BANG_CUS_APPLICATION",
  url: "/api/bang/cus-application",
  method: "post",
  data: {
      copy:'',    //身份证人像
      national:'',  //身份证国徽
      number:'',
      name:'',
      valid_time:'',
      mobile_number:'',
      bank_acct_no:'', //银行卡号
      bank_code:'', //银行编码 xx银行
      bank_branch_code:'', //开户行联行号 xx银行xx支行
      // bank_address_code:'110000', // 开户行所在地编码
      // profession:'49900',  //职业，默认传这个吧
      sms_code:'', //验证码
  },
};

// 换绑银行卡 V2 和上面认证是一样的参数，就是换个路径
export const POST_BANG_CUS_APPLICATION_RENEW = {
  name: "POST_BANG_CUS_APPLICATION_RENEW",
  url: "/api/bang/cus-application-renew",
  method: "post",
  data: {
      copy:'',    //身份证人像
      national:'',  //身份证国徽
      number:'',
      name:'',
      valid_time:'',
      mobile_number:'',
      bank_acct_no:'', //银行卡号
      bank_code:'', //银行编码 xx银行
      bank_branch_code:'', //开户行联行号 xx银行xx支行
      // bank_address_code:'110000', // 开户行所在地编码
      // profession:'49900',  //职业，默认传这个吧
      sms_code:'', //验证码
  },
};

// 换绑银行卡 
export const POST_BANG_SETTLE_ACCT = {
  name: "POST_BANG_SETTLE_ACCT",
  url: "/api/bang/settle-acct",
  method: "post",
  data: {
    bank_acct_type:'personal',
    mobile_number:'',
    bank_acct_no:'', //银行卡号
    bank_code:'', //银行编码 xx银行
    bank_branch_code:'', //开户行联行号 xx银行xx支行
    sms_code:'', //验证码
  },
};


// 新增或更新创作者的徽章 
export const POST_EDIT_CREATOR_BADGE = {
    name: "POST_EDIT_CREATOR_BADGE",
    url: "/api/badge/edit-creator-badge",
    method: "post",
    data: {
        images:'',    //图标地址列表，逗号分隔
        badge_id:'',  //不传表示新增
        selected_plan:'',
    },
};

// 获取创作者的徽章列表 
export const GET_CREATOR_BADGE_LIST = {
    name: "GET_CREATOR_BADGE_LIST",
    url: "/api/badge/get-creator-badge-list",
    method: "get",
    data: {},
};

// 获得徽章提示分享弹窗信息
export const GET_BADGE_FIRST_SHOW = {
  name: "GET_BADGE_FIRST_SHOW",
  url: "/api/badge/first_show",
  method: "get",
  data: {creator_id:''},
};


// 更新创作者可见的备注
export const POST_ORDER_UPDATE_CREATOR_REMARK = {
  name: "POST_ORDER_UPDATE_CREATOR_REMARK",
  url: "/api/order/update-creator-remark",
  method: "post",
  data: {out_trade_no:'', creator_remark: ''},
};

// 获取 oauth client_id信息
export const POST_OAUTH2_CLIENT_INFO = {
  name: "POST_OAUTH2_CLIENT_INFO",
  url: "/api/oauth2/client_info",
  method: "post",
  data: {client_id:''},
};

// oauth 认证
export const POST_OAUTH2_AUTHORIZE = {
  name: "POST_OAUTH2_AUTHORIZE",
  url: "/api/oauth2/authorize",
  method: "post",
  data: {response_type:'', client_id: '', redirect_uri: '', state: '', scope: ''},
};

// 编辑商品排序
export const POST_EDIT_PLAN_RANK = {
  name: "POST_EDIT_PLAN_RANK",
  url: "/api/creator/edit-plan-rank",
  method: "post",
  data: {plan_ids:''},
};

// 获取实名信息
export const GET_USER_IDCARD = {
  name: "GET_USER_IDCARD",
  url: "/api/user/idcard",
  method: "get",
  data: {},
};

// 设置购票人信息
export const POST_USER_IDCARD_VALIDATE = {
  name: "POST_USER_IDCARD_VALIDATE",
  url: "/api/user/idcard-validate",
  method: "post",
  data: {id_card:'',name:'',phone:'',license_type:'',is_self: ''},
};

// 编辑购票人信息
export const POST_USER_EDIT_IDCARD = {
  name: "POST_USER_EDIT_IDCARD",
  url: "/api/user/edit-idcard",
  method: "post",
  data: {id_card:'',name:'',phone:'',license_type:'',id: ''},
};

// 删除购票人信息
export const GET_USER_DELETE_IDCARD = {
  name: "GET_USER_DELETE_IDCARD",
  url: "/api/user/delete-idcard",
  method: "get",
  data: {id:''},
};

// 获取所有购票人
export const GET_ALL_IDCARDS = {
  name: "GET_ALL_IDCARDS",
  url: "/api/user/all-idcards",
  method: "get",
  data: {},
};

// 获取订单购票信息
export const GET_ORDER_TICKETS = {
  name: "GET_ORDER_TICKETS",
  url: "/api/order/tickets",
  method: "get",
  data: {out_trade_no:''},
};

// 验票
export const GET_ORDER_TICKET_CHECKIN = {
  name: "GET_ORDER_TICKET_CHECKIN",
  url: "/api/order/ticket-checkin",
  method: "get",
  data: {out_trade_no:'',id:''},
};

// 删除聊天列表item
export const GET_MESSAGE_DELETE_DIALOG = {
  name: "GET_MESSAGE_DELETE_DIALOG",
  url: "/api/message/delete-dialog",
  method: "get",
  data: {user_id:''},
};

// 获取举报下拉框
export const GET_REPORT_PREPARE = {
  name: "GET_REPORT_PREPARE",
  url: "/api/user/report-prepare",
  method: "get",
  data: {object_type:''}, 
};

// 举报接口
export const POST_REPORT = {
  name: "POST_REPORT",
  url: "/api/user/report",
  method: "post",
  data: {object_type:'', object_id:'', report_type:'', report_reason: ''}, 
};

// 支付宝解约
export const GET_AGREEMENT_UNSIGN = {
  name: "GET_AGREEMENT_UNSIGN",
  url: "/api/agreement/unsign",
  method: "get",
  data: {external_agreement_no:''}, 
};

// 短链兑换
export const GET_ORDER_TRANSFER_PAY_URL = {
  name: "GET_ORDER_TRANSFER_PAY_URL",
  url: "/api/order/transfer-pay-url",
  method: "get",
  data: {out_trade_no:''}, 
};




